<template>
  <section class="hero">
    <div class="hero__title">
      <h1
        :data-anim="$store.state.nextType !== 'next2' ? 'title' : false"
        data-trans="next"
      >
        {{ data.brand }} <span>. {{ data.name }}</span>
      </h1>
    </div>
    <div
      class="hero__bg"
      :style="{ transform: `translate3d(0, ${hades.ref.amount.y}px, 0)`, }"
    >
      <div
        class="hero__bg__filler"
        :style="{ opacity: 0.3 + Math.min(hades.ref.amount.y / windowH, 0.7) }"
      />
      <div
        class="hero__bg__image"
        :style="{ backgroundImage: `url(/static/images/${data.id}/00_${data.id}.jpg)`, }"
      />
      <div
        class="hero__next__image"
        :style="{ backgroundImage: `url(${next.image})`, }"
      />
    </div>
    <div
      class="hero__next"
      data-trans="next"
      v-if="next"
    >
      <a
        href="#!"
        @click="(e) => {
          e.preventDefault();
          $store.commit('NEXT_TYPE', 'next2');
          $router.push(`/esposizione/${next.id}`)
        }"
      >
        <h1 data-anim="fade" data-trans="next2" data-delay="0.5">
          {{ next.brand }} <span>. {{ next.name }}</span>
        </h1>
      </a>
    </div>
  </section>
</template>

<script>
import hades from '@/scripts/hades';

export default {
  name: 'Hero',

  props: {
    data: {
      type: Object,
      required: true,
    },
    next: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      hades,
      windowH: window.innerHeight,
    };
  },
};
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  width: 100%;
  height: 100vh;

  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;

  @include mq($and: $is-touch-device) {
    height: 400px;
  }

  &__title {
    position: relative;
    overflow: hidden;
    padding-left: 5px;
    padding-right: 5px;

    h1 {
      margin: 0;
    }
  }

  &__next {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translate3d(calc(-1 * (100vw / 32 * 3)), -50%, 0);
    opacity: 0.3;
    z-index: 4;
    pointer-events: auto;
    transition: opacity 0.2s ease-out 0.1s;
    white-space: nowrap;

    &:hover {
      opacity: 1;
    }

    @include mq($until: ipadL) {
      display: none;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    z-index: -1;
    background-size: cover;
    background-position: 50% 50%;
    pointer-events: none;

    @include mq($and: $is-touch-device) {
      transform: none !important;
      position: fixed;
    }

    &__image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      z-index: -1;
      background-size: cover;
      background-position: 50% 50%;
    }

    &__filler {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: RGB($color-bg);
      mix-blend-mode: multiply;

      @at-root body[data-theme="day"] & {
        mix-blend-mode: unset;

        @media (prefers-color-scheme: dark) {
          mix-blend-mode: multiply;
        }
      }

      /* @media (prefers-color-scheme: light) {
        mix-blend-mode: unset;
      } */

    }
  }
}

.hero__next__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: -1;
  background-size: cover;
  background-position: 50% 50%;
  opacity: 0;
  pointer-events: none;
}
</style>
